<template>
  <button class="button-toggle" :data-off="!state.isVisibleMCSPController" @click="toggleMCSPController">
    <ToggleSwitch :model-value="state.isVisibleMCSPController" @update:modelValue="toggleMCSPController" />
    {{ t('label_mcsp') }}
  </button>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import { DEFAULT_CHAT_UI_STATE } from '@/utils/constants/chat';
import { ij_chat_ui, ij_setCurrentPopupMicInput } from '@/utils/injectionKeys';

const { t } = useI18n();

const { actions, state } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE);
const setCurrentPopupMicInput = inject(ij_setCurrentPopupMicInput, (str) => {});

const toggleMCSPController = () => {
  if (state.isVisibleMCSController) {
    actions.toggleMCSController();
  }
  actions.toggleMCSPController();
  setCurrentPopupMicInput('');
};
</script>

<style scoped lang="scss"></style>
